export default {
  ADD_NOTIFICATION: 'ADD_NOTIFICATION',
  CLOSE_NOTIFICATION: 'CLOSE_NOTIFICATION',
  CLOSE_ALL_NOTIFICATIONS: 'CLOSE_ALL_NOTIFICATIONS',
  RESET_NOTIFICATION_TIMER: 'RESET_NOTIFICATION_TIMER',
  CLEAR_NOTIFICATION_TIMER: 'CLEAR_NOTIFICATION_TIMER',
};
